import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessageWithClass, Image, Link } from '../commonComponents';
import content from 'Content/content.json';
import FooterConfig, { isEmptySocial } from '../../configuration/Footer';
import { language, LANG_JP, LANG_VI, LANG_AZ } from 'Root/constants';
import { Youtube_icon, Facebook_icon, Ins_icon } from '../commonComponents/svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './footer.scss';
import { ClickLayer } from '../../ga4';
// Todo: Move all constants and process.env to Utils.js
// Todo: Refactor JSX into subcomponents
import { FormattedMessage, useIntl } from 'react-intl';

const footerText = content['data']['footerText'][language];
const warningText = content['data']['warningText'][language];
const footerTextAdditional = content['data']['footerTextAdditional'][language];

const footerLinks = {
  'about': process.env.REACT_APP_ACUVUE,
  'contact': process.env.REACT_APP_CONTACT_US,
  'privacy': process.env.REACT_APP_PRIVACY_POLICY,
  'legal': process.env.REACT_APP_LEGAL_NOTICE,
  'patient_guide': process.env.REACT_APP_PATIENT_GUIDE
};

const socialLinks = {
  'facebook': process.env.REACT_APP_FACEBOOK ? process.env.REACT_APP_FACEBOOK : null,
  'twitter': process.env.REACT_APP_TWITTER ? process.env.REACT_APP_TWITTER : null,
  'youtube': process.env.REACT_APP_YOUTUBE ? process.env.REACT_APP_YOUTUBE : null,
  'instagram': process.env.REACT_APP_INSTAGRAM ? process.env.REACT_APP_INSTAGRAM : null,
  'kakao': process.env.REACT_APP_KAKAO ? process.env.REACT_APP_KAKAO : null,
  'weibo': process.env.REACT_APP_WEIBO ? process.env.REACT_APP_WEIBO : null,
  'wechat': process.env.REACT_APP_WECHAT ? process.env.REACT_APP_WECHAT : null,
  'zhihu': process.env.REACT_APP_ZHIHU ? process.env.REACT_APP_ZHIHU : null,
};

// console.log(footerLinks, socialLinks, 'footer');

const SHOW_COOKIE_POLICY = process.env.REACT_APP_SHOW_COOKIE_POLICY || 'no';
// console.log(SHOW_COOKIE_POLICY, 'cookie');

const EmptySocial = Object.values(socialLinks).every(link => link === null || link === '');

const Footer = ({history}) => {
  const { formatMessage } = useIntl();
  const {
    links: { parent_link, social_link },
  } = FooterConfig();

  const redirectTo = () => {
    history.push('cookie-policy');
  };

  const filteredLinks = (links) => links.filter((link) => link.href);
  const { REACT_APP_BUILD_DATE } = process.env;
  return (
    <footer className="footer">
      <div className='footer-wrapper'>
        <ul className='links'>
        { SHOW_COOKIE_POLICY != 'no' && <div className="cookie-policy-footer-wrapper">
          <div className="cookie-policy-footer-inner">
            <span id='ot-sdk-btn' className='ot-sdk-show-settings nolink'>
            <FormattedMessage id="footer.cookie" defaultMessage='Cookie Settings' />
            </span>
            <figure onClick={() => redirectTo()}>
              <FormattedMessageWithClass
                className='cookie-policy-footer'
                id='cookie_policy.cookie_policy_footer'
                defaultMessage="Cookie Policy"
              />
            </figure>
          </div>
        </div>}
          <a
            href={footerLinks.about}
            >
            <FormattedMessage id="footer.about" defaultMessage='About Acuvue® Define™' />
          </a>
          <a
            href={footerLinks.contact}
            >
            <FormattedMessage id="footer.contact" defaultMessage='Contact Us' />
          </a>
          <a
            href={footerLinks.privacy}
            >
              <FormattedMessage id="footer.policy" defaultMessage='privacy policy' />
            </a>
          <a
            href={footerLinks.legal}
            >
              <FormattedMessage id="footer.notice" defaultMessage='legal notice' />
          </a>
        </ul>
        <ul className='socials'>
          {socialLinks.facebook &&
          <a href={socialLinks.facebook} target="_blank">
            <Facebook_icon />
          </a>}
          {socialLinks.instagram &&
          <a href={socialLinks.instagram} target="_blank">
            <Ins_icon />
          </a>}
          {socialLinks.youtube &&
          <a href={socialLinks.youtube} target="_blank">
            <Youtube_icon />
          </a>
          }
        </ul>
        <div className='legal' dangerouslySetInnerHTML={{ __html: formatMessage({id:"footer.legal", defaultMessage:"<p>© Johnson & Johnson International (Singapore) Pte Ltd 2023. All rights reserved. This site is published by Johnson & Johnson Vision, which is solely responsible for its content. It is intended for use by residents of Singapore.</p> <p>ACUVUE® OASYS, HydraLuxe™, MOIST, DEFINE®, Natural Shine®, Radiant Bright™, Radiant Charm™, Radiant Sweet™, Radiant Chic™, LACREON®, HYDRACLEAR®, INTUISIGHT™, EYELID STABILIZED are trademarks of Johnson & Johnson Vision ©, Johnson & Johnson International (Singapore) Pte. Ltd. 2023</p>" }) }}>
        </div>
      </div>
    </footer>
  );
};

export default withRouter(Footer);
